import organisationInterviewFormatTemplates from "./organisation-interview-format-templates";

export const ORGANISATION_INTERVIEW_FORMAT_TEMPLATES_NAMESPACE =
  "organisations/organisationInterviewFormatTemplates";

export default organisationInterviewFormatTemplates;
